import React, { useState } from "react";
import { WebhookWrapper } from "./components";
import axios from "axios";

const Webhook = () => {
  const [hookState, setHookState] = useState({
    name: "",
  });

  const [newInputKey, setNewInputKey] = useState("");

  const handleClick = () => {
    axios.post("http://localhost:9000/webhook/test", hookState);
  };

  const hanldeObjectAdd = (key) => {
    setHookState((prev) => ({ ...prev, [newInputKey]: "" }));
    setNewInputKey("");
  };

  const handleInputKeyChange = (key, val) => {
    setHookState((prev) => ({ ...prev, [key]: val }));
  };

  return (
    <WebhookWrapper>
      {Object.entries(hookState).map(([key]) => (
        <div>
          <label>{key}</label>
          <input key={key} onChange={(e) => handleInputKeyChange(key, e.target.value)} />
        </div>
      ))}
      <button onClick={handleClick}> Click to send the info </button>

      <div>
        <input value={newInputKey} onChange={(e) => setNewInputKey(e.target.value)} />
        <button onClick={hanldeObjectAdd}> Add object key </button>
      </div>
    </WebhookWrapper>
  );
};

export default Webhook;
